import { render, staticRenderFns } from "./checkboxCom.vue?vue&type=template&id=65561d6e&scoped=true"
import script from "./checkboxCom.vue?vue&type=script&lang=js"
export * from "./checkboxCom.vue?vue&type=script&lang=js"
import style0 from "./checkboxCom.vue?vue&type=style&index=0&id=65561d6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65561d6e",
  null
  
)

export default component.exports